import type { SeccionCatalogo, SeccionInput } from './queries';

type Nivel = 'ninguno' | 'ver' | 'editar';

/** Tabla de secciones con nivel por fila: sin acceso, ver o editar (según lo que admite cada una). */
export function EditorSecciones({
  catalogo,
  valor,
  onCambio,
  deshabilitado = false,
}: {
  catalogo: SeccionCatalogo[];
  valor: SeccionInput[];
  onCambio: (v: SeccionInput[]) => void;
  deshabilitado?: boolean;
}) {
  const nivelDe = (s: string): Nivel => valor.find((v) => v.section === s)?.level ?? 'ninguno';
  const poner = (section: SeccionInput['section'], nivel: Nivel) => {
    const resto = valor.filter((v) => v.section !== section);
    onCambio(nivel === 'ninguno' ? resto : [...resto, { section, level: nivel }]);
  };
  return (
    <div className="overflow-x-auto">
      <table className="tabla-cs w-full text-sm">
        <thead>
          <tr>
            <th>Sección</th>
            <th className="text-center">Sin acceso</th>
            <th className="text-center">Ver</th>
            <th className="text-center">Editar</th>
          </tr>
        </thead>
        <tbody>
          {catalogo.map((c) => (
            <tr key={c.section}>
              <td className="font-semibold">{c.name}</td>
              {(['ninguno', 'ver', 'editar'] as const).map((n) => {
                const admite = n === 'ninguno' || (c.levels as string[]).includes(n);
                return (
                  <td key={n} className="text-center">
                    {admite ? (
                      <input
                        type="radio"
                        name={`seccion-${c.section}`}
                        className="h-4 w-4 accent-[var(--color-azul-600)]"
                        checked={nivelDe(c.section) === n}
                        disabled={deshabilitado}
                        onChange={() => poner(c.section as SeccionInput['section'], n)}
                        aria-label={`${c.name}: ${n}`}
                      />
                    ) : (
                      <span className="text-texto-3">—</span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
